import {SQFTResourceController} from "./SQFTResourceController";
import {WORKSPACE_RESOURCES} from "../../../../constants";
import store from "../../../../../../store";
import workspace from "../../core/workspace";
import {LineHandlesModel} from "../models/LineHandlesModel";

export class HandlesController extends SQFTResourceController {

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.handles;
  }

  generateHandles() {
    const reduxState = store.getState();
    const selectedPartIds = reduxState.sqftResourceState.selectedPartIds
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      if (selectedPartIds.includes(shape.partId)) {
        this.addHandleToTheShape(shape);
      }
    }
  }

  addHandleToTheShape(shape) {
    const reduxState = store.getState();
    const selectedFeature = reduxState.sqftResourceState.selectedFeature
    const lines = shape.getLines();
    for (const lineIndex in lines) {
      if (+lineIndex === 2) {
        if (lines.hasOwnProperty(lineIndex)) {
          lines[lineIndex].setHandleId(selectedFeature.part.dbFeature.id);
          const handle3dURL = this.findGLBModel(selectedFeature.part.dbFeature.thirdPartyAR3DUrls, 'V')
          lines[lineIndex].setHandle3dURL(handle3dURL);
          this.addResource(new LineHandlesModel(lines[lineIndex].id, selectedFeature.part.dbFeature.id));
        }
      }
    }
  }

  /**
   * Function to find a .glb model in the array based on H or V suffix.
   * If the parameter is not passed or no matching model is found, it returns the first .glb model found.
   *
   * @param {Array} urls - Array of URLs.
   * @param {String} [suffix] - Optional. Suffix 'H' or 'V' to search for in the URL.
   * @returns {String} - The found .glb model URL or the first .glb model in the array.
   */
  findGLBModel(urls, suffix) {
    if (!urls) {
      return null
    }

    const glbModels = urls.filter(url => url.endsWith('.glb'));

    if (!glbModels.length) {
      return null;
    }

    // If suffix is provided (either 'H' or 'V'), search for a model with that suffix
    if (suffix) {
      const modelWithSuffix = glbModels.find(url => url.endsWith(`-${suffix}.glb`));
      if (modelWithSuffix) {
        return modelWithSuffix;
      }
    }

    return glbModels[0];
  }

  exportHandles() {
    return this.export()
  }
}

